import Head from "next/head";
import Routes from "../src/routes/Routes";
import Contact from "../src/components/pages/contact/Contact";

const nextContactus = () => {
  return (
    <>
      <Head>
        <title>Contact Garden Office (GO) Bermondsey for Private Office Space Availability</title>
        <meta name="description" content="Get in touch with Garden Office (GO) Bermondsey to check private office space availability, book a tour, or learn more about our premium workspaces." />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link rel="canonical" href={`${Routes?.domain}${Routes?.contact_us}`} />
      </Head>
          
       <Contact/>
    </>
  );
};

export default nextContactus;
